/* ui/game/Winner.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text
} from "svelte/internal";

import { winnerStore } from "../store";

function add_css() {
	var style = element("style");
	style.id = "svelte-r300v8-style";
	style.textContent = "label.svelte-r300v8{color:white;font-size:2em}";
	append(document.head, style);
}

// (16:0) {#if winner !== ''}
function create_if_block(ctx) {
	let label;
	let t;

	return {
		c() {
			label = element("label");
			t = text(/*winner*/ ctx[0]);
			attr(label, "class", "svelte-r300v8");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			append(label, t);
		},
		p(ctx, dirty) {
			if (dirty & /*winner*/ 1) set_data(t, /*winner*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(label);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let if_block = /*winner*/ ctx[0] !== "" && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (/*winner*/ ctx[0] !== "") {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let winner;

	winnerStore.subscribe(value => {
		$$invalidate(0, winner = value);
	});

	return [winner];
}

class Winner extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-r300v8-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Winner;